import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// `roles` (opcional): sólo esos roles entran a la ruta; el resto vuelve al dashboard.
const ProtectedRoute = ({ children, roles }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    // Si no está autenticado, redirige al login
    return <Navigate to="/login" />;
  }

  if (roles) {
    // Mientras se carga el perfil todavía no se conoce el rol.
    if (!user) return null;
    if (!roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  }

  // Si está autenticado (y tiene el rol requerido), renderiza el componente hijo
  return children;
};

export default ProtectedRoute;
